import * as React from "react";
import {
    IconButtonClear,
    OverlayStyledInputBase,
    Search,
} from "./LocationSearchTextField.styles";
import { SearchTextFieldOpts } from "./LocationSearchTextField.types";
import { useRef } from "react";
import { SearchIcon } from "../../../Icon/SearchIcon";
import { CircleXMarkIcon } from "../../../Icon/CircleXMarkIcon";

export function LocationSearchTextField(props: SearchTextFieldOpts) {
    const { searchInput, onSearch, determineUserAddress } = props;

    const showClear = searchInput && searchInput.length > 0;

    const searchInputRef = useRef<HTMLInputElement>();

    return (
        <Search>
            <OverlayStyledInputBase
                startAdornment={
                    <SearchIcon
                        color="var(--community-color-secondary-text)"
                        width="20px"
                        height="20px"
                    />
                }
                onClick={() => {
                    if (window.scrollY) {
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });
                    }
                }}
                onChange={(e) => {
                    onSearch(e.target.value);
                }}
                placeholder="Ort suchen"
                value={searchInput}
                id="contentSearchBar"
                inputRef={searchInputRef}
            />
            {showClear && (
                <IconButtonClear
                    onClick={() => {
                        onSearch("");
                        searchInputRef.current?.blur();
                    }}
                >
                    <CircleXMarkIcon fill="var(--community-color-transparent-black-20)" />
                </IconButtonClear>
            )}
        </Search>
    );
}
